import * as StatStripXpress2Messages from '../misc/api/DeviceLinkApi/StatStripXpress2Messages';
import { ApiGetResults, ApiClearResults, BloodGlucoseResult } from '../misc/api/DeviceLinkApi/StatStripXpress2';
import { uploadTests } from '../misc/api/SerenityBloodGlucoseTests';
import { logErrorToServer } from '../errors/LogErrorToServer';
import { DevicesAction, DevicesState, SetUploadStatusAction, SetInteractionModalStepAction, SelectActiveSessionForUploadAction } from './DevicesNewReducer';
import { WebPortalLegacyClientInternal } from '../misc/api/WebPortalTokenClient';
import { User } from 'oidc-client-ts';
import { BloodGlucoseSessionStatusEnum } from '../misc/api/apiTypes';
import { WebPortalClient } from 'webportalclient';

export class UploadBloodGlucoseSessionsAsyncAction {
    public static async Upload(client: WebPortalClient, dispatch: React.Dispatch<DevicesAction>, state: DevicesState, user: User) {
        try {
            dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.RetrievingTestsMessage));
            const results = await ApiGetResults(state.activeSelectedDevice.id);

            if (!results) return;

            if (results.length === 0) {
                dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.NoTestsToUploadMessage));
                return dispatch(SetInteractionModalStepAction.create(5));
            }

            if (state.upload.selectedSessionIds.length !== 1) return;

            for (const sessionId of state.upload.selectedSessionIds) {

                if (!await this.uploadTests(client, dispatch, state, sessionId, results, user)) return;
            }
                
            dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.UploadedSuccessfullyMessage(results.length)));
            dispatch(SetInteractionModalStepAction.create(4));

        }
        catch (err) {
            logErrorToServer(err, `Failed uploading StatStrip Xpress 2 device`);
            dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.FailedToUploadMessage));
            dispatch(SetInteractionModalStepAction.create(5));
        }
    }

    private static async uploadTests(client: WebPortalClient, dispatch: React.Dispatch<DevicesAction>, currentState: DevicesState, sessionId: string, results: BloodGlucoseResult[], user: User) {

        dispatch(SelectActiveSessionForUploadAction.create(sessionId));
        dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.UploadingTestsMessage));

        try {
            await uploadTests(sessionId, results, user);
        }
        catch (err) {
            logErrorToServer(err, "Failed uploading StatStrip Xpress 2 tests");

            const testCount = results.length;

            dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.TestCountFailedToUploadMessage(testCount, testCount)));
            dispatch(SetInteractionModalStepAction.create(5));

            return false;
        }

        const isClearSuccess = await ApiClearResults(currentState.activeSelectedDevice.id);

        if (!isClearSuccess.isSuccess) {
            dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.FailedToCleanDeviceMessage));
            dispatch(SetInteractionModalStepAction.create(5));
        }

        const sessionUpdateResponse = await client.patchBloodGlucoseSession(
        {
            technician: user.profile.email,
            status: BloodGlucoseSessionStatusEnum.ReceivedData,
        }, sessionId, "");

        if (sessionUpdateResponse.status !== BloodGlucoseSessionStatusEnum.ReceivedData) {
            dispatch(SetUploadStatusAction.create(StatStripXpress2Messages.FailedUpdatingSessionStatus));
        }

        return true;
    }
}
